import {
	ButtonUtility,
	LoadingIndicator,
	MetricCard,
	PageHeader,
	PriorityCards,
} from "@components";
import { CheckCircle, Share04, SlashCircle01, Tool02 } from "@untitledui/icons";
import dayjs from "dayjs";
import { CarIcon } from "@/components/ui/icons/CarIcon";
import { Image } from "@/components/ui/image";
import {
	DashboardEventsMetricsSection,
	DashboardRankingSection,
} from "../components";
import { useFleetStats } from "../hooks/useFleetStats";

function DashboardWelcome() {
	return (
		<div className="mb-8 flex flex-col items-center gap-2">
			<Image
				alt="Fleeter Logo"
				className="h-12 w-12 shrink-0 md:h-16 md:w-16"
				height={48}
				src="/fleeter_logo.svg"
				width={48}
			/>
			<h1 className="text-center font-semibold text-[32px] text-brand-500 leading-[40px]">
				Boas vindas ao Fleeter!
			</h1>
			<p className="text-center font-medium text-primary text-xl leading-[30px]">
				Insights e prioridades para decisões mais rápidas
			</p>
		</div>
	);
}

export default function DashboardPage() {
	const { data: stats, isLoading } = useFleetStats();

	const currentTime = dayjs().format("HH:mm");
	const weekStart = dayjs().startOf("week").format("DD/MM");
	const weekEnd = dayjs().endOf("week").format("DD/MM");

	if (isLoading) {
		return (
			<div className="w-full px-6 py-8">
				<DashboardWelcome />
				<output className="flex flex-col items-center justify-center py-16">
					<LoadingIndicator
						label="Carregando dados da frota"
						size="md"
						type="line-simple"
					/>
				</output>
			</div>
		);
	}

	return (
		<div className="w-full px-6 py-8">
			<DashboardWelcome />

			<section
				aria-labelledby="dashboard-fleet-status-heading"
				className="mb-6"
			>
				<PageHeader
					actions={
						<ButtonUtility
							color="secondary"
							href="/vehicles"
							icon={Share04}
							size="sm"
							tooltip="Abrir lista de veículos"
						/>
					}
					className="mb-4"
					subtitle={`Visão completa da sua frota. Última atualização às ${currentTime}h.`}
					title={
						<span id="dashboard-fleet-status-heading">
							Status Geral da Frota
						</span>
					}
					titleAs="h2"
				/>

				<div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-4">
					<MetricCard
						icon={<CarIcon className="size-full" />}
						title="Total de Veículos"
						tone="info"
						value={stats?.total ?? 0}
					/>
					<MetricCard
						icon={<CheckCircle className="size-full" />}
						title="Em operação"
						tone="success"
						value={stats?.inOperation ?? 0}
					/>
					<MetricCard
						icon={<Tool02 className="size-full" />}
						title="Em manutenção"
						tone="warning"
						value={stats?.inMaintenance ?? 0}
					/>
					<MetricCard
						icon={<SlashCircle01 className="size-full" />}
						title="Fora de operação"
						tone="error"
						value={stats?.outOfOperation ?? 0}
					/>
				</div>
			</section>

			<div className="mb-6">
				<PriorityCards
					actions={
						<ButtonUtility
							color="secondary"
							href="/copilot/summary"
							icon={Share04}
							size="sm"
							tooltip="Abrir insights do Copiloto"
						/>
					}
					subtitle={`Prioridades identificadas com base nos dados da frota. (${weekStart} a ${weekEnd})`}
					title="Insights do Copiloto"
				/>
			</div>

			<DashboardRankingSection />

			<DashboardEventsMetricsSection />
		</div>
	);
}
